import { gql } from "@apollo/client";export default gql`mutation AddGroupTabMap($objects: [home_explore_group_tab_map_insert_input!]!) {
    addGroupTabMap: insert_home_explore_group_tab_map(objects: $objects) {
        affected_rows
    }
}
`;
